module.exports = __webpack_public_path__ + "img/ho-zerox.6995248f.jpg";